<li class="selectable"><a href="#" class="btn btn-tertiary grid-manage-filters-link-btn">{{locale "manageFilters"}}</a></li>